import { render, staticRenderFns } from "./TiEditorNew.vue?vue&type=template&id=2cac2860&"
import script from "./TiEditorNew.vue?vue&type=script&lang=js&"
export * from "./TiEditorNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports